import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyBa80bxXr0KNZ2Gywt8W6GLo5RFPkgBM60",
  authDomain: "workouttracker-ac550.firebaseapp.com",
  databaseURL: "https://workouttracker-ac550-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "workouttracker-ac550",
  storageBucket: "workouttracker-ac550.firebasestorage.app",
  messagingSenderId: "415444974916",
  appId: "1:415444974916:web:12ea5dacc51e8151322b11",
  measurementId: "G-CZHEB8MTK8"
};


export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);
export const firebaseApp = firebaseConfig;

export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('abcdefghijklmnopqrstuvwxy-1234567890abcd'),
  isTokenAutoRefreshEnabled: true
});